export default axios => ({

  validate (departmentId, appointmentId, payload) {
    return axios.post(`${departmentId}/appointment/${appointmentId}/validate`, payload);
  },
  getList (departmentId, payload) {
    return axios.get(`${departmentId}/appointment/list`, payload);
  },
  update (departmentId, id, payload) {
    return axios.patch(`${departmentId}/appointment/${id}`, payload);
  },
  delete (departmentId, id) {
    return axios.delete(`${departmentId}/appointment/${id}`);
  },
  findClient (departmentId) {
    return axios.get(`/appointment/findClient/${departmentId}`);
  },
  save (departmentId, payload) {
    return axios.post(`/${departmentId}/appointment`, payload);
  },
  paymentTypes () {
    return axios.get(`/appointments/payment-types`);
  },

  slot (payload) {
    let params = {
      params: {
        user_id: payload.user,
        date: payload.date
      }
    }

    return axios.get(`${payload.departmentId}/appointment/slot/${payload.procedureId}`, params);
  },

})
